// eslint-disable-next-line import/prefer-default-export -- follow nav messages file pattern
export const invertedMessages = {
  'There was a problem loading your shortcuts. Refresh the page to retry.':
    'Nav.ShortcutsWidget.RequestError',
} as const;
